export const convertToFullStateName: { [key: string]: string } = {
  CA: 'California',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  MD: 'Maryland',
  MA: 'Massachusetts',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  TX: 'Texas',
  UT: 'Utah',
  DC: 'Washington DC',
  WA: 'Washington',
}
